import { TAxisOptions } from '../types/types';

export const symbols = [
  'circle',
  'diamond',
  'triangle-down',
  'triangle',
];

export const gridLineStyle: TAxisOptions = {
  gridLineDashStyle: 'Solid',
  gridLineColor: '#E1DFDD',
  tickPixelInterval: 150,
};
